import { render, staticRenderFns } from "./ModalMaster.vue?vue&type=template&id=2bf98502&"
import script from "./ModalMaster.vue?vue&type=script&lang=js&"
export * from "./ModalMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports